import { AppState } from "../../../redux-configuration/AppState";

export const registrationStepSelector = (appState: AppState): number => appState.registration.step
